var addToCartButton;
var quickCheckoutButton;
var miniCartButton = document.querySelector('.cart-toggle');
var continueShoppingBtn = document.querySelector('#continueShoppingBtn');

var removeItemButton = document.querySelectorAll('.jsRemoveCartItem');

for (var i = 0; i < removeItemButton.length; i++) {
    removeItemButton[i].onclick = removeItemFromCart;
}

if (miniCartButton !== null) {
    miniCartButton.addEventListener('click', toggleMiniCart);
}

if (continueShoppingBtn !== null) {
    continueShoppingBtn.onclick = hideMiniCart;
}

function initLargeCart() {
    var cartQtyTextbox = document.querySelectorAll('.jsChangeQuantityItemCart');
    var cartRemoveLink = document.querySelectorAll('.jsRemoveCartItem');

    for (var c = 0; c < cartQtyTextbox.length; c++) {
        cartQtyTextbox[c].onchange = cartUpdateQuantity;
    }

    for (var d = 0; d < cartRemoveLink.length; d++) {
        cartRemoveLink[d].onclick = cartRemoveItem;
    }
}

function initQuickCheckout() {
    quickCheckoutButton = document.querySelector('.quickCheckoutButton');
    if (quickCheckoutButton !== null) {
        quickCheckoutButton.addEventListener('click', addAndFastCheckout);
    }
}

function initCartService() {
    addToCartButton = document.querySelector('.addToCart');

    if (addToCartButton !== null) {
        addToCartButton.addEventListener('click', addProductToCart);
    }
}

function cartUpdateQuantity(event) {
    var el = this;

    var quantity = parseInt(el.value);
    var code = el.getAttribute('data-code');
    var url = el.getAttribute('data-url');
    var shipmentId = el.getAttribute('data-shipmentid');

    
    try {
        // ODP remove from cart event.
        if (quantity == 0) {
            zaius.event('product', { action: 'remove_from_cart', product_id: code });
        }
    }
    catch { }

    var itemsPartial = document.querySelector('#jsCartItemsPartial');

    fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ code: code, quantity: quantity, shipmentId: shipmentId })
    })
        .then(function (res) {
            return res.text();
        })
        .then(function (html) {
            // Update cart items list
            itemsPartial.innerHTML = html;

            // Update cart summary
            var cartSummaryBlock = document.querySelector('.cart-summary__body');
            var jsHiddenCartSummary = document.querySelector('.jsHiddenCartSummary');
            cartSummaryBlock.innerHTML = jsHiddenCartSummary.innerHTML;

            // Update cart badge
            var newCountSpan = document.querySelector('.jsHiddenCartItemsCount');
            updateCartCount(newCountSpan.innerHTML);

            // Reinit cart update functions
            initLargeCart();
        })
        .catch(function (err) {
            console.log(err);
        });
}

function cartRemoveItem(event) {
    var el = this;

    var code = el.getAttribute('data-code');
    var url = el.getAttribute('data-url');
    var shipmentId = el.getAttribute('data-shipmentid');

    
    try {
        // ODP remove from cart event.
        zaius.event('product', { action: 'remove_from_cart', product_id: code });
    }
    catch { }

    var itemsPartial = document.querySelector('#jsCartItemsPartial');

    fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ code: code, quantity: 0, shipmentId: shipmentId })
    })
        .then(function (res) {
            return res.text();
        })
        .then(function (html) {
            // Update cart items list
            itemsPartial.innerHTML = html;

            // Update cart summary
            var cartSummaryBlock = document.querySelector('.cart-summary__body');
            var jsHiddenCartSummary = document.querySelector('.jsHiddenCartSummary');
            cartSummaryBlock.innerHTML = jsHiddenCartSummary.innerHTML;

            // Update cart badge
            var newCountSpan = document.querySelector('.jsHiddenCartItemsCount');
            updateCartCount(newCountSpan.innerHTML);

            // Reinit cart update functions
            initLargeCart();
        })
        .catch(function (err) {
            console.log(err);
        });
}

function addAndFastCheckout(event) {
    var el = this;

    var sku = el.getAttribute('data-sku');
    var productCode = el.getAttribute('data-prod');
    var action = el.getAttribute('data-action');
    var language = el.getAttribute('data-lang');
    var fastUrl = el.getAttribute('data-fastcheckouturl');

    
    try {
        //ODP add to cart event.
        zaius.event('product', { action: 'add_to_cart', product_id: productCode });
    }
    catch { }

    window.fetch(action, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ code: sku, language: language, productCode: productCode, requestForm: "js-fetch" })
        })
        .then(function (res) {
            return res.json();
        })
        .then(function (res) {
            var data = res;

            window.location.href = fastUrl;
        })
        .catch(function (err) {
            console.log(err);
        });
}

function addProductToCart(event) {
    var el = this;

    var sku = el.getAttribute('data-sku');
    var productCode = el.getAttribute('data-prod');
    var action = el.getAttribute('data-action');
    var language = el.getAttribute('data-lang');

    try {
        // ODP add to cart event.
        zaius.event('product', { action: 'add_to_cart', product_id: productCode });
    }
    catch { }

    window.fetch(action, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ code: sku, language: language, productCode: productCode, requestForm: "js-fetch" })
    })
        .then(function (res) {
            return res.json();
        })
        .then(function (res) {
            var data = res;

            debugger; 

            showNotification(data.statusCode, data.message, false);
            updateCartCount(data.countItems);
        })
        .catch(function (err) {
            console.log(err);
        });
}

function removeItemFromCart(event) {
    event.preventDefault();

    var el = this;
    var code = el.getAttribute('data-code');
    var shipment = el.getAttribute('data-shipmentId');
    var action = el.getAttribute('data-action');
    var sender = el.getAttribute('data-sender'); //cartPopover

    try {
        // ODP remove from cart event.
        zaius.event('product', { action: 'remove_from_cart', product_id: code });
    }
    catch { }

    fetch(action, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ code: code, shipment: shipment, requestForm: 'js-fetch' })
    })
        .then(function (res) {
            return res.json();
        })
        .then(function (result) {
            var data = result;

            showNotification(data.statusCode, data.message, true);
            updateCartCount(data.countItems);

            if (sender === 'cartPopover') {
                var cartPopover = document.querySelector('#js-cart-popover');
                cartPopover.style.display = 'none';
            }
        })
        .catch(function (err) {
            console.log(err);
        });
}

function showNotification(code, message, removed) {

    debugger;

    var notification = document.querySelector('#cart-notification');
    var notification_dialog = document.querySelector('#cart-notification-dialog');

    if (code === 0) {
        notification_dialog.innerHTML = '<span class="title">' + message + '</span>';
    }
    else if (code === 1 || code === -1) {

        var notificationHtml = '<span class="title">' + message + '</span>';
        var notificationBottom = "";
        var checkoutLink = "";
        var checkoutText = "";
        var cartLink = "";
        var cartText = "";
        var continueText = "";

        //Find checkout and cart buttons in Header/_headerCartPartial
        var checkoutBtn = document.querySelector('#checkoutBtnId');
        if (checkoutBtn !== null && checkoutBtn !== undefined) {
            checkoutLink = checkoutBtn.getAttribute('href');
            checkoutText = checkoutBtn.innerHTML;
        }

        var cartBtn = document.querySelector('#cartBtnId');
        if (cartBtn !== null && cartBtn !== undefined) {
            cartLink = cartBtn.getAttribute('href');
            cartText = cartBtn.innerHTML;
        }

        var continueBtn = document.querySelector('#continueShoppingBtn');
        if (continueBtn !== null && continueBtn !== undefined) {
            continueText = continueBtn.innerHTML;
        }

        if (!checkoutText) {
            if (checkoutBtn?.data?.legal) {
                checkoutText = "Inquire";
            } else {
                checkoutText = "Checkout";
            }
        }

        if (!cartText) {
            if (cartBtn?.data?.legal) {
                cartText = "Inquire";
            } else {
                cartText = "Checkout";
            }
        }

        if (!continueText) {
            if (continueBtn?.data?.legal) {
                continueText = "Continue browsing";
            } else {
                continueText = "Continue shopping";
            }
        }

        if (!removed) {
            if (cartBtn !== null && cartBtn !== undefined) {    // New Checkout flow - Start at cart page
                notificationBottom = `<div class='notification__controls'>
                    <a href='#' id='messageCloseBtn' class='button  button--diapositive'><span>${continueText}</span></a>
                    <a href='${cartLink}' class='button  button--primary'><span>${cartText}</span></a>
                </div>`;
            }
            else {
                notificationBottom = `<div class='notification__controls'>
                    <a href='#' id='messageCloseBtn' class='button  button--diapositive'><span>${continueText}</span></a>
                    <a href='${checkoutLink}' class='button  button--primary'><span>${checkoutText}</span></a>
                </div>`;
            }
            notificationHtml += notificationBottom;
        }
        else {
            notificationBottom = `<div class='notification__controls'>
                <a href='#' id='messageCloseBtn' class='button  button--diapositive'><span>${continueText}</span></a>
            </div>`;

            notificationHtml += notificationBottom;
        }

        notification_dialog.innerHTML = notificationHtml;
    }

    notification.style.display = 'block';

    var closeBtn = document.querySelector('#messageCloseBtn');
    if (closeBtn !== null) {
        closeBtn.onclick = function (event) { notification.style.display = 'none'; };
    }
}

function updateCartCount(newCount) {
    var badge = document.querySelector('.cart-badge');
    badge.innerHTML = newCount;
}

function hideMiniCart(event) {
    var cartPopover = document.querySelector('#js-cart-popover');
    cartPopover.style.display = 'none';
}

function toggleMiniCart(event) {
    event.preventDefault();

    var cartPopover = document.querySelector('#js-cart-popover');
    var invisible = cartPopover.style.display === 'none';

    var miniCartContents = document.querySelector('#mini-cart-contents');
    var miniCartLoader = document.querySelector('#mini-cart-loader');

    if (invisible) {

        miniCartContents.style.display = 'none';
        miniCartLoader.style.display = 'block';
        cartPopover.style.display = 'block';

        window.fetch('/DefaultCart/MiniCartDetails', {
            method: 'GET',
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache'
            },
        })
            .then(function (res) {
                return res.text();
            })
            .then(function (html) {
                miniCartContents.innerHTML = html;
                miniCartLoader.style.display = 'none';
                miniCartContents.style.display = 'block';

                var removeItemButton = document.querySelectorAll('.jsRemoveCartItem');
                for (var r = 0; r < removeItemButton.length; r++) {
                    removeItemButton[r].onclick = removeItemFromCart;
                }

                var continueShoppingBtn = document.querySelector('#continueShoppingBtn');
                if (continueShoppingBtn !== null) {
                    continueShoppingBtn.onclick = hideMiniCart;
                }
            })
            .catch(function (err) {
                console.log(err);
            });
    }
    else {
        cartPopover.style.display = 'none';
    }
}

initCartService();
initQuickCheckout();
initLargeCart();